import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND_ROOT = process.env.REACT_APP_BACKEND_URL?.endsWith("/api")
  ? process.env.REACT_APP_BACKEND_URL.slice(0, -4)
  : process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("yopinion_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
};

export const withBackendUrl = (path) => {
  if (!path) return path;
  if (path.startsWith("/api/uploads")) {
    return `${BACKEND_ROOT}${path}`;
  }
  if (path.startsWith("/uploads")) {
    return `${BACKEND_ROOT}/api${path}`;
  }
  return path;
};

export default api;
